import React from 'react';

/**
 * Cape Town's skyline - Devil's Peak, Table Mountain and the city's towers -
 * along the foot of a page of cards. Under the photo band the grey around the
 * cards read as empty (the user, 2026-10-21); the band's own view, drawn as a
 * faint outline, closes the page the way the photo opens it.
 *
 * Traced from the band's photo (assets/CapeTown_Seed.png at 1920 wide), not
 * drawn freehand: the ridge is the photo's sky line found column by column,
 * and each tower is measured off it. The towers are lifted towards the ridge
 * so the whole view fits a strip about a ninth as tall as it is wide, and none
 * rises above the mountain it stands in front of.
 *
 * Decorative: hidden from assistive technology and never printed. Colours and
 * strengths live in index.css (.page-skyline). It takes the bottom of the
 * page at every width (margin-top: auto in PageShell's column), so on a phone
 * it stands on the footer instead of floating under the cards.
 */
const RIDGE = 'M0,68 L8,68 L28,76 L36,76 L64,68 L72,68 L84,65 L96,58 L104,50 L116,49 L132,31 '
  + 'L136,17 L148,6 L164,5 L184,9 L208,9 L236,20 L240,20 L252,24 L292,33 L304,41 L308,49 L320,55 '
  + 'L328,61 L332,66 L348,76 L364,75 L388,76 L408,75 L412,76 L424,82 L428,82 L448,92 L452,96 '
  + 'L480,98 L496,114 L508,122 L516,125 L528,127 L548,138 L560,138 L568,134 L580,131 L596,122 '
  + 'L604,121 L636,122 L644,113 L648,105 L652,103 L660,80 L676,66 L680,66 L688,62 L716,60 L736,55 '
  + 'L780,51 L788,48 L808,49 L816,52 L856,61 L900,61 L924,59 L956,60 L968,57 L1004,57 L1016,55 '
  + 'L1076,55 L1136,53 L1192,54 L1212,53 L1220,52 L1224,50 L1244,49 L1288,50 L1308,47 L1356,47 '
  + 'L1388,49 L1400,47 L1404,42 L1408,41 L1436,38 L1452,38 L1488,31 L1504,31 L1528,29 L1536,27 '
  + 'L1564,26 L1592,23 L1620,23 L1624,21 L1636,20 L1672,20 L1696,18 L1704,20 L1708,23 L1712,34 '
  + 'L1716,54 L1720,60 L1728,61 L1732,66 L1740,71 L1752,72 L1772,67 L1792,66 L1796,67 L1804,75 '
  + 'L1816,76 L1820,80 L1824,81 L1848,82 L1852,80 L1860,80 L1864,82 L1868,88 L1872,90 L1880,90 '
  + 'L1884,93 L1892,93 L1896,95 L1920,95';

// Masts and rooftop blocks stop at the roof they stand on, so no outline runs
// through the tower beneath.
const TOWERS = 'M10,149H108V220H10Z M45,79H50V149H45Z M80,91H89V149H80Z M108,201H150V220H108Z '
  + 'M478,194H528V220H478Z M528,205H575V220H528Z M621,151H709V220H621Z M659,141H663V151H659Z '
  + 'M733,137H812V220H733Z M759,114H788V137H759Z M812,201H841V220H812Z M841,139H929V220H841Z '
  + 'M955,156H973V220H955Z M975,86H1040V220H975Z M1040,60H1100V220H1040Z M1100,92H1113V220H1100Z '
  + 'M1113,127H1145V220H1113Z M1145,122H1217V220H1145Z M1163,104H1197V122H1163Z '
  + 'M1450,187H1500V220H1450Z M1500,189H1555V220H1500Z';

const CapeTownSkyline = () => (
  <svg
    className="page-skyline no-print"
    viewBox="0 0 1920 220"
    preserveAspectRatio="xMidYMax meet"
    aria-hidden="true"
    focusable="false"
  >
    <path className="page-skyline-mountain" d={`${RIDGE} L1920,220 L0,220 Z`} />
    <path className="page-skyline-city" d={TOWERS} />
    <path className="page-skyline-ridge" d={RIDGE} />
  </svg>
);

export default CapeTownSkyline;
